// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contInputFormV2 {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center
}
.contInputFormV2.error-cont {
   width: 90%;
}
.compactInputFormV2 {
    display: flex;
    flex-direction: column;
    width: 95%;
    height: 95%;
    justify-content: center;
    align-items: center;
}
.labelInputFormV2{
    display: flex;
    font-size: 1em;
    font-weight: bold;
    color: var(--third-color);
    align-self: flex-start;
    margin-bottom: 5px;
    position: relative;
    width: 100%;
    height: 20% ;
    align-items: inherit;
}
.InputFormV2{
    width: 100%;
    position: relative;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    padding-left: 10px;
    
    color: var(--txt-color);
    

  font-size: var(--font-size-med);
 

  border: 2px solid var(--border-table-color);
  border-radius: 4px;
 
  background: transparent;
  height: 80%;
}
.disabled-input{
    background-color: rgba(183, 183, 183, 0.22);
    cursor:none
}
.labelInputFormV2 .comment{
    color: var(--txt-color);
      position: relative;
  left: 10%;
}
.labelInputFormV2.error-input{
    color: var(--red-alert) !important;
}
.reqField-V2 {
  color: var(--red-alert);
  font-size: large;
  position: relative;
  top: -20% !important;
  left: 1%;
  height: 100%;

}

.msg-error-cont{
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

}
.icon-msg-error:hover{
    cursor: pointer;

}
.tooltip-error-txt {
  visibility: hidden;
  width: 200px;
  background-color: #ffb0b0cc;
  color: #830202;
  border: 1px solid #830202b0;
  box-shadow: 3px 3px 6px rgba(87, 0, 0, 0.445);
  text-align: left;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  z-index: 1;
 
  /* left: 50%; */
  transform: translateX(-60%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: var(--font-size-small);
  overflow-y:'auto';
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-height: 100%;
  overflow: auto;
}

.msg-error-cont:hover .tooltip-error-txt {
  visibility: visible;
  opacity: 1;
}

.tooltip-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tooltip-list li {
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/generales/styles/InputForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB;AACJ;AACA;GACG,UAAU;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;;IAElB,uBAAuB;;;EAGzB,+BAA+B;;;EAG/B,2CAA2C;EAC3C,kBAAkB;;EAElB,uBAAuB;EACvB,WAAW;AACb;AACA;IACI,2CAA2C;IAC3C;AACJ;AACA;IACI,uBAAuB;MACrB,kBAAkB;EACtB,SAAS;AACX;AACA;IACI,kCAAkC;AACtC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,YAAY;;AAEd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;IACI,eAAe;;AAEnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;;EAEV,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;EACxB,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".contInputFormV2 {\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center\r\n}\r\n.contInputFormV2.error-cont {\r\n   width: 90%;\r\n}\r\n.compactInputFormV2 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 95%;\r\n    height: 95%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.labelInputFormV2{\r\n    display: flex;\r\n    font-size: 1em;\r\n    font-weight: bold;\r\n    color: var(--third-color);\r\n    align-self: flex-start;\r\n    margin-bottom: 5px;\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20% ;\r\n    align-items: inherit;\r\n}\r\n.InputFormV2{\r\n    width: 100%;\r\n    position: relative;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 5px;\r\n    padding-left: 10px;\r\n    \r\n    color: var(--txt-color);\r\n    \r\n\r\n  font-size: var(--font-size-med);\r\n \r\n\r\n  border: 2px solid var(--border-table-color);\r\n  border-radius: 4px;\r\n \r\n  background: transparent;\r\n  height: 80%;\r\n}\r\n.disabled-input{\r\n    background-color: rgba(183, 183, 183, 0.22);\r\n    cursor:none\r\n}\r\n.labelInputFormV2 .comment{\r\n    color: var(--txt-color);\r\n      position: relative;\r\n  left: 10%;\r\n}\r\n.labelInputFormV2.error-input{\r\n    color: var(--red-alert) !important;\r\n}\r\n.reqField-V2 {\r\n  color: var(--red-alert);\r\n  font-size: large;\r\n  position: relative;\r\n  top: -20% !important;\r\n  left: 1%;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.msg-error-cont{\r\n    width: 10%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n.icon-msg-error:hover{\r\n    cursor: pointer;\r\n\r\n}\r\n.tooltip-error-txt {\r\n  visibility: hidden;\r\n  width: 200px;\r\n  background-color: #ffb0b0cc;\r\n  color: #830202;\r\n  border: 1px solid #830202b0;\r\n  box-shadow: 3px 3px 6px rgba(87, 0, 0, 0.445);\r\n  text-align: left;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  position: absolute;\r\n  z-index: 1;\r\n \r\n  /* left: 50%; */\r\n  transform: translateX(-60%);\r\n  opacity: 0;\r\n  transition: opacity 0.3s;\r\n  font-size: var(--font-size-small);\r\n  overflow-y:'auto';\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  max-height: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.msg-error-cont:hover .tooltip-error-txt {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.tooltip-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.tooltip-list li {\r\n  margin-bottom: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
